import React from "react";
import { useOverlayPopupOpen } from "../../hooks/use-overlay-popup-open";
import "../shared/popup-card.scss";

interface ClaimWorkshopOptionsProps {
  visible: boolean;
  onSelectContracted: () => void;
  onSelectNonContracted: () => void;
}

export const ClaimWorkshopOptions: React.FC<ClaimWorkshopOptionsProps> = ({
  visible,
  onSelectContracted,
  onSelectNonContracted,
}) => {
  useOverlayPopupOpen(visible);
  if (!visible) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-card">
        <h3 className="popup-title">اختر مركز الإصلاح</h3>
        <div className="popup-options">
          <button
            onClick={onSelectContracted}
            className="popup-option-btn"
            style={{ background: "linear-gradient(-90deg, #0049e6 0%, #829bff 100%)", color: "#fff", borderColor: "transparent", boxShadow: "0 6px 18px rgba(0,73,230,0.28)" }}
          >
            <span className="popup-option-icon">🏢</span>
            <div className="popup-option-text">
              <div className="popup-option-label" style={{ color: "#fff" }}>مركز خدمة متعاقد</div>
              <div className="popup-option-desc" style={{ color: "rgba(255,255,255,0.88)" }}>اختر من قائمة المراكز المتعاقدة</div>
            </div>
          </button>
          <button
            onClick={onSelectNonContracted}
            className="popup-option-btn"
            style={{ background: "linear-gradient(-90deg, #1b5cff 0%, #98afff 100%)", color: "#fff", borderColor: "transparent", boxShadow: "0 6px 18px rgba(27,92,255,0.22)" }}
          >
            <span className="popup-option-icon">🔧</span>
            <div className="popup-option-text">
              <div className="popup-option-label" style={{ color: "#fff" }}>مركز خدمة غير متعاقد</div>
              <div className="popup-option-desc" style={{ color: "rgba(255,255,255,0.88)" }}>أدخل بيانات مركز خدمة آخر</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};
